import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-start flex-wrap page-header" }
const _hoisted_2 = { class: "page-header-title mr-2" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "d-flex align-center flex-wrap ml-auto page-header-actions" }
const _hoisted_5 = {
  key: 1,
  class: "page-header-tabs"
}
const _hoisted_6 = {
  key: 2,
  class: "page-header-below"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_color_accent = _resolveComponent("ontos-color-accent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_action_group = _resolveComponent("ontos-action-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.accent)
      ? (_openBlock(), _createBlock(_component_ontos_color_accent, {
          key: 0,
          vertical: "",
          color: _ctx.accent,
          class: "page-header-accent"
        }, null, 8, ["color"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), {
          class: _normalizeClass([_ctx.headingClass, "page-header-heading"]),
          title: _ctx.title
        }, {
          default: _withCtx(() => [
            (_ctx.icon)
              ? (_openBlock(), _createBlock(_component_v_icon, {
                  key: 0,
                  start: "",
                  color: _ctx.iconColor || undefined
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.icon), 1)
                  ]),
                  _: 1
                }, 8, ["color"]))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.title), 1)
          ]),
          _: 1
        }, 8, ["class", "title"])),
        (_ctx.subtitle || _ctx.$slots.subtitle)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["text-subtitle-2 text-grey page-header-subtitle", {'page-header-subtitle--rich': !!_ctx.$slots.subtitle}]),
              title: _ctx.subtitle
            }, [
              _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.subtitle), 1)
              ], true)
            ], 10, _hoisted_3))
          : _createCommentVNode("", true)
      ], true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.$slots.actions)
        ? (_openBlock(), _createBlock(_component_ontos_action_group, { key: 0 }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "controls", {}, undefined, true)
    ]),
    (_ctx.$slots.tabs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "tabs", {}, undefined, true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.$slots.below)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "below", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}